<template>
    <div v-if="showLoader" class="ticket-loader-wrapper">
        <dialog ref="dialogEl" class="ticket-loader">
            <div class="ticket-loader__content">
                <div class="ticket-loader__icon">
                    <SazkaSpinLoader :size="24" />
                </div>
                <div class="ticket-loader__text-wrapper">
                    <h2 class="ticket-loader__title">Probíhá vsazení tiketu...</h2>
                    <p v-if="showText" class="ticket-loader__text">
                        Zpracovat tuto sázku chvíli trvá, nezavírejte aplikaci.
                    </p>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef, onMounted, onUnmounted, ref, watchEffect } from "vue";
import { useTicketStore } from "@/ticket/stores/use-ticket-store";
import { TicketSending } from "@/ticket/model/ticket-sending";
import SazkaSpinLoader from "@/shared/components/atoms/SazkaSpinLoader.vue";

const dialogEl = ref<HTMLDialogElement>(null);

const ticketStore = useTicketStore();

const showLoader: ComputedRef<boolean> = computed(() => Boolean(ticketStore.sendingInProgress));
const showText: ComputedRef<boolean> = computed(() => ticketStore.sendingInProgress === TicketSending.Longer);

watchEffect(() => {
    if (dialogEl.value) {
        if (showLoader.value) {
            dialogEl.value.showModal();
        } else {
            dialogEl.value.close();
        }
    }
});

onMounted(() => {
    if (dialogEl.value) dialogEl.value.showModal();
});
onUnmounted(() => {
    if (dialogEl.value) dialogEl.value.close();
});
</script>
